<template>
  <div class="common-aside">
    这是Page1页面
  </div>
</template>

<script>
export default {
    name: "PageOne",
}
</script>

<style>

</style>